import { persistState } from '@storeon/localstorage';
import { createStoreon } from 'storeon';
import appStore, { IAppEvents, IAppStore } from './appStore';
import dependentStore, { IDependentEvents, IDependentStore } from './dependentStore';
import eligibilityStore, { IEligibilityEvents, IEligibilityStore } from './eligibilityStore';
import navigationStore, { INavigationEvents, INavigationStore } from './navigationStore';
import reviewSelectionStore, { IReviewEvents, IReviewStore } from './reviewSelectionStore';
import sidebarStore, { ISidebarEvents, ISidebarStore } from './sidebarStore';
import subscriberStore, { ISubscriberEvents, ISubscriberStore } from './subscriberStore';

type State = IAppStore & IEligibilityStore & ISubscriberStore & IDependentStore & IReviewStore & ISidebarStore & INavigationStore;
type Events = IAppEvents & IEligibilityEvents & ISubscriberEvents & IDependentEvents & IReviewEvents & ISidebarEvents & INavigationEvents;

export default createStoreon<State, Events>([
  appStore,
  sidebarStore,
  navigationStore,
  eligibilityStore,
  subscriberStore,
  dependentStore,
  reviewSelectionStore,
  persistState(['appStore', 'sidebarStore', 'eligibilityStore', 'subscriberStore', 'dependentStore', 'reviewSelectionStore'], { storage: sessionStorage }),
])
